import React, { useState, useEffect } from 'react'
import { Input, CalendarPicker, Dialog, WaterMark, Toast, Button, DotLoading, SpinLoading, PullToRefresh, NavBar, List } from 'antd-mobile'
import { useNavigate, useLocation } from "react-router-dom";
import TrainTable from './TrainTable';
// import AreaChart from './AreaChart';
import { Area } from '@ant-design/plots';
import { useSwipeable } from 'react-swipeable';
import * as api from '../../services/api';
import { useOKRequest } from '../../hooks';
import { getAuth } from '../../modules/auth';
import './patientDetails.css';

function PatientDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [loading, setLoading] = useState(false);
  console.log('loading', loading)

  // 获取表格数据
  const [listData, setListData] = useState([])
  const { data: listObj, run: gainPatientOneListByNo } = useOKRequest(() =>
    api.gainPatientOneListByNo({
      no: searchParams.get('no'),
      curTime: date,
      page: 1,
      pageSize: 100,
    }), {
    manual: true,
  }
  );
  useEffect(() => {
    setListData(listObj?.data?.result?.records)
  }, [listObj])
  console.log('listData', listData)

  // 获取每日训练时长
  const [chartsData, setChartsData] = useState([])
  const { data: dataObj, run: gainChartsData } = useOKRequest(() =>
    api.gainPatientOneListByNo({
      no: searchParams.get('no'),
      curTime: 'fantasy',
    })
  );
  useEffect(() => {
    const arr = dataObj?.data?.result?.records?.map((item) => ({
      start: item.start,
      startMD: item.startMD,
      totalTime: item.totalTime
    }));
    // setChartsData(arr?.reverse())
    setChartsData(arr)
  }, [dataObj])
  console.log('chartsData', chartsData)


  // 删除患者接口
  const { loading: deleteLoading, run: delPatient } = useOKRequest(api.delPatient, {
    manual: true,
    onSuccess: (res) => {
      if (res.data.code === 200) {
        Toast.show({
          content: '删除成功',
        })
        Dialog.clear() //关闭弹窗
        navigate('/PatientList')
      } else {
        Toast.show({
          content: res.data.message,
        })
      }
      setLoading(false);
    },
    onError: (err) => {
      setLoading(false); // 请求失败后设置 loading 为 false
    },
  });

  // 删除事件
  const deleteUser = () => {
    Dialog.show({
      content: <div className='patientDetails_dialog'>
        {(searchParams.get('deadline') !== 'null' && searchParams.get('deadline')) ? '患者存在个人授权时长，请联系经销商解除授权后删除' : '是否确认删除患者？'}
      </div>,
      actions: [
        (searchParams.get('deadline') !== 'null' && searchParams.get('deadline')) ?
          [{
            key: 'cancel',
            text: <div className='patientDetails_action c_576B95'>我知道了</div>,
            onClick: () => {
              Dialog.clear() //关闭弹窗
            }
          }]
          :
          [{
            key: 'cancel',
            text: <div className='patientDetails_action c_353535'>否</div>,
            onClick: () => {
              Dialog.clear() //关闭弹窗
            }
          },
          {
            key: 'confirm',
            text: <div className='patientDetails_action c_576B95'
            // onClick={() => {
            //   delPatient({ id: '' })
            //   setLoading(true)
            //   console.log('loading111', loading)
            //   console.log('deleteLoading', deleteLoading)
            // }}
            >
              是
              {/* {loading ? <SpinLoading /> : '是'} */}
              {/* <SpinLoading /> */}
              {/* {deleteLoading ? <SpinLoading /> : '是'} */}
            </div>,
            onClick: () => {
              // setLoading(true)
              delPatient({ id: searchParams.get('id') })
            }
            // text: <div className='patientDetails_action c_576B95'>
            //   <Button
            //     loading={deleteLoading}
            //     block
            //     onClick={() => {
            //       delPatient({ id: searchParams.get('id') });
            //     }}
            //   >
            //     是
            //   </Button>
            // </div>
          }]
      ],
    });
  }

  // 日期转换
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  // 选择日期
  const [date, setDate] = useState(formatDate(new Date()))
  const [visibleDate, setVisibleDate] = useState(false)

  // 表头
  const columns = [
    { title: '训练开始时间', dataIndex: 'start' },
    { title: '训练时长', dataIndex: 'totalTime' },
  ];

  // 面积图
  const config = {
    // data: chartsData,
    xField: 'startMD',
    yField: 'totalTime',
    style: {
      fill: 'linear-gradient( -270deg, rgba(11,162,89,0.12) 0%, rgba(11,162,89,0) 100%)', // 设置渐变颜色
    },
    label: {
      text: 'totalTime',
      fontSize: 10,
      fontColor: '#636262',
      position: 'outside',
      transform: [{ type: 'overlapDodgeY' }],
    },
    axis: {
      y: { labelFormatter: '~s' },  // 格式化（如1000->1k）
      x: {
        label: {
          // autoHide: true,
          // autoRotate: false,
          // autoScale: true,
        },
      }
    },
    line: {
      style: {
        strokeWidth: 2,
        stroke: '#0CAF60', // 设置线条颜色
      },
    },
    tooltip: false,
    // tooltip: {
    //   formatter: (datum) => {
    //     console.log('datum',datum)
    //     return [
    //       { name: '值', value: datum.value },
    //     ];
    //   },
    // },
    // tooltip: {
    //   showMarkers: true, // 显示标记
    //   shared: true, // 共享提示
    //   customContent: (title, items) => {
    //     return (
    //       `<div style="padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
    //          <div style="margin-bottom: 5px; font-weight: bold;">${title}</div>
    //          ${items.map(item => `
    //            <div style="margin-bottom: 5px;">
    //              <span style="background-color: ${item.color}; width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></span>
    //              ${item.name}: ${item.value}
    //            </div>
    //          `).join('')}
    //        </div>`
    //     );
    //   }
    // },
    interactions: [{ type: 'tooltip' }]
  };
  const [startIndex, setStartIndex] = useState(0);
  useEffect(() => {
    // 初始化 startIndex 为最后 7 项的起点
    const initialIndex = chartsData?.length > 7 ? chartsData?.length - 7 : 0;
    setStartIndex(initialIndex);
  }, [chartsData]);
  const handleScroll = (direction) => {
    // setStartIndex((prevIndex) => {
    //   const newIndex = prevIndex + direction;
    //   if (newIndex < 0) {
    //     return 0;
    //   } else if (newIndex + 7 > chartsData.length) {
    //     return chartsData.length - 7;
    //   } else {
    //     return newIndex;
    //   }
    // });
    setStartIndex((prevIndex) => {
      const newIndex = prevIndex + direction;
      if (newIndex < 0) {
        return 0;
      } else if (newIndex > chartsData.length - 7) {
        return Math.max(chartsData.length - 7, 0); // 保持正确的索引范围
      } else {
        return newIndex;
      }
    });
  };
  // const [currentData, setCurrentData] = useState([])
  const currentData = chartsData?.slice(startIndex, startIndex + Math.min(7, chartsData.length)) || []; // 先取最后 7 项或小于 7 项
  // useEffect(() => {
  //   setCurrentData(chartsData?.slice(startIndex, startIndex + Math.min(7, chartsData.length)))
  // }, [startIndex])
  // console.log('startIndex', startIndex)
  console.log('currentData', currentData)
  // 使用手势库实现滑动效果
  const handlers = useSwipeable({
    // onSwipedLeft: () => handleScroll(1),
    // onSwipedRight: () => handleScroll(-1),
    onSwipedLeft: () => chartsData?.length > 7 && handleScroll(1),
    onSwipedRight: () => chartsData?.length > 7 && handleScroll(-1),
  });

  useEffect(() => {
    gainPatientOneListByNo()
  }, [date]);


  return (
    <div className='PatientDetails'>
      <NavBar
        // back='患者详情' 
        onBack={() => navigate(-1)}>
        患者详情
      </NavBar>
      <WaterMark fontColor='rgba(0, 0, 0, .1)' content={[getAuth()?.depart_name, getAuth()?.realname]} />
      <PullToRefresh
        onRefresh={async () => {
          gainPatientOneListByNo()
          gainChartsData()
        }}
      >
        <div className="PatientDetails_Container">
          <div className="PatientDetails_baseInfo">
            <div className="PatientDetails_baseInfo-left">
              <img
                src={searchParams.get('sex') === '男' ? './images/avator2.png' : './images/avator1.png'}
                alt="" />
              <div className='PatientDetails_baseInfo-leftInfo'>
                <div className="PatientDetails_baseInfo-leftName">{searchParams.get('name')}</div>
                <div className="PatientDetails_baseInfo-leftSex">{searchParams.get('sex')} {searchParams.get('age')}岁 {searchParams.get('phoneNo')}</div>
              </div>
            </div>
            <div
              className="PatientDetails_baseInfo-right"
              onClick={deleteUser}
            >删除</div>
          </div>
          <div className="PatientDetails_divider"></div>
          <div className="PatientDetails_trainInfo">
            <div className="PatientDetails_trainInfo-title">训练信息</div>
            <div className="PatientDetails_trainInfo-item">
              <img
                src={searchParams.get('mode') === '3' ? './images/left.png' : searchParams.get('mode') === '4' ? './images/right.png' : './images/two.png'}
                alt="" />
              <div className="PatientDetails_trainInfo-itemRight">{searchParams.get('modeName')}</div>
            </div>
            {(searchParams.get('deadline') !== 'null' && searchParams.get('deadline')) && <div className="PatientDetails_trainInfo-item">
              <img
                src='./images/confirm.png'
                alt="" />
              <div className="PatientDetails_trainInfo-itemRight">个人版已授权，至{searchParams.get('deadline')}</div>
            </div>}
          </div>
          <div className="PatientDetails_divider"></div>
          <div className="PatientDetails_charts">
            <div className="PatientDetails_charts-top">
              <div className="PatientDetails_charts-title">每日训练时长（min）</div>
            </div>
            <div className="PatientDetails_charts-botttom">
              {chartsData ?
                <div
                  {...handlers}
                  style={{ width: '100%', height: '230px' }}
                >
                  <Area {...config} data={currentData} />
                </div>
                // <AreaChart data={chartsData} style={{ width: '100%', height: '100%' }} />
                :
                <>
                  <img src="./images/noData.png" alt="" />
                  <div className="PatientDetails_charts-botttomText">未找到数据</div>
                </>
              }
            </div>
          </div>
          <div className="PatientDetails_divider"></div>
          <div className="PatientDetails_table">
            <div className="PatientDetails_charts-top">
              <div className="PatientDetails_charts-title">选择时间</div>
              <div
                className='PatientDetails_table-picker'
                onClick={() => {
                  setVisibleDate(true)
                }}
              >
                <Input
                  className='input'
                  placeholder='选择日期'
                  value={date}
                  readOnly
                />
                <div className='dateIcon'>
                  <img
                    src="./images/date.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <CalendarPicker
              visible={visibleDate}
              selectionMode='single'
              defaultValue={new Date()}
              max={new Date()}
              min={new Date('2020-01-01')}
              onClose={() => setVisibleDate(false)}
              // onMaskClick={() => setVisibleDate(false)}
              onConfirm={(val) => {
                setDate(formatDate(val))
              }}
            />
            {/* {visibleDate && <LazyCalendarPicker visible={visibleDate} onConfirm={(val) => setDate(val)} onClose={() => setVisibleDate(false)} />} */}
            {listData ? <div className="PatientDetails_table-bottom">
              <TrainTable columns={columns} dataSource={listData} />
            </div>
              :
              <div className="PatientDetails_charts-botttom">
                <img src="./images/noData.png" alt="" />
                <div className="PatientDetails_charts-botttomText">未找到数据</div>
              </div>
            }
          </div>
        </div>
      </PullToRefresh>
    </div >
  );
}

export default PatientDetails;

// const LazyCalendarPicker = ({ visible, onConfirm, onClose }) => {
//   useEffect(() => {
//     // 在这里可以进行组件初始化或其他懒加载逻辑
//   }, []);

//   return (
//     <CalendarPicker
//       visible={visible}
//       selectionMode="single"
//       defaultValue={new Date()}
//       max={new Date()}
//       min={new Date('1970-01-01')}
//       onClose={onClose}
//       onConfirm={onConfirm}
//     />
//   );
// };